export const inboundFreightStatusOptions = [
  { label: "Arrived", value: "ARRIVED" },
  { label: "Inbound", value: "INBOUND" },
  { label: "Late", value: "LATE" },
  { label: "Alert", value: "ALERT" }
];

export interface InboundPickupSummaryResponse {
  serviceCenter: ServiceCenter;
  assignedSummary: PickupSummary | null;
  unassignedSummary: PickupSummary | null;
  completedSummary: PickupSummary | null;
}

export interface ServiceCenter {
  terminalNumber: number;
  terminalName: string;
  airportCode: string;
  addressLine1: string;
  addressLine2: string;
  city: string;
  state: string;
  zipcode: number;
  terminalRegion: string;
  terminalTimeZone: string;
  managerName: string;
  managerPhoneNumber: string;
  managerEmail: string;
  terminalEmail: string;
  hub: string;
  hubNumb: string;
  primary: boolean;
}

export interface PickupSummary {
  destinationTerminal: number;
  totalPickups: number;
  totalItems: number;
  totalWeight: number;
  totalDrivers: number;
}

export interface InboundFreightSummary {
  originTerminalNumber: number;
  originTerminalName: string;
  originAirportCode: string;
  numberOfShipments: number;
  numberOfPieces: number;
  weight: number;
  numberOfTrailers: number;
  earliestEta: string; // YYYY-MM-DD
  latestEta: string;   // YYYY-MM-DD
}

export interface DestinationFreightSummary {
  destinationTerminal: number;
  destinationName: string;
  destinationAirportCode: string;
  pros: number;
  pieces: number;
  weight: number;
  squareYards: number;
  revenue: number;
  earliestEta: string; // YYYY-MM-DD
  latestEta: string;   // YYYY-MM-DD
}

export interface AssignedSummary {
  assignedSummary: SummaryStats | null;
  completedSummary: SummaryStats | null;
  inboundFreights: InboundFreight | null;
  inhouseFreights: FreightDetails | null;
  serviceCenter: ServiceCenter;
  unassignedSummary: UnassignedSummary;
}

/* ------------------ Shared / Reusable Interfaces ------------------ */

export interface SummaryStats {
  destinationTerminal: number;
  totalDrivers: number;
  totalItems: number;
  totalPickups: number;
  totalWeight: number;
}

export interface FreightDetails {
  destinationAirportCode: string;
  destinationName: string;
  destinationTerminal: number;
  earliestEta: string; // YYYY-MM-DD
  latestEta: string;   // YYYY-MM-DD
  pieces: number;
  pros: number;
  revenue: number;
  squareYards: number;
  weight: number;
  numberOfTrailers: number;
}

export interface InboundFreight {
  destinationTerminal: number;
  destinationName: string;
  destinationAirportCode: string;
  numberOfShipments: number;
  numberOfPieces: number;
  weight: number;
  numberOfTrailers: number;
  earliestEta: string;
  latestEta: string;
}

/* ------------------ Service Center ------------------ */

export interface ServiceCenter {
  airportCode:string;
  terminalName:string;
  terminalNumber:number;
}

/* ------------------ Unassigned Summary ------------------ */

export interface UnassignedSummary {
  destinationTerminal: number;
  totalDrivers: number;
  totalItems: number;
  totalPickups: number;
  totalWeight: number;
}
